import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const CircleSlash2: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '12', r: '10' }],
    ['path', { d: 'M22 2 2 22' }],
  ],
];

export default CircleSlash2;
